(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const init = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('[data-gallery-root]').forEach((root) => {
      const viewport = root.querySelector('[data-gallery-viewport]');
      if (!viewport) return;
      const frames = Array.from(viewport.children);
      const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
      const behavior = () => (reduced.matches ? 'auto' : 'smooth');

      const go = (delta) => {
        const rtl = document.documentElement.dir === 'rtl' ? -1 : 1;
        viewport.scrollBy({ left: viewport.clientWidth * delta * rtl, behavior: behavior() });
      };
      root.querySelectorAll('[data-gallery-prev]').forEach((btn) => {
        btn.hidden = false;
        btn.addEventListener('click', () => go(-1));
      });
      root.querySelectorAll('[data-gallery-next]').forEach((btn) => {
        btn.hidden = false;
        btn.addEventListener('click', () => go(1));
      });

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          const target = root.querySelector(thumb.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: behavior(), block: 'nearest', inline: 'center' });
        });
      });

      if ('IntersectionObserver' in window && thumbs.length) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = frames.indexOf(entry.target);
            thumbs.forEach((thumb, i) => {
              thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
            });
          });
        }, { root: viewport, threshold: 0.6 });
        frames.forEach((frame) => observer.observe(frame));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    // Swapped-in markup carries [data-animate] but was never seen by the global reveal
    // observer, so it would stay hidden. Two frames: the first commits the hidden state
    // so the transition still plays; the class add itself guarantees it can never stick.
    revealSwapped() {
      // Prefer the global observer so the row staggers when it is actually scrolled
      // to, rather than playing its whole sequence off-screen while the fetch resolves.
      const A = window.Atar;
      if (A && A.reveal) { A.reveal(this); return; }
      const items = this.querySelectorAll('[data-animate]');
      if (!items.length) return;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        items.forEach((el) => el.classList.add('is-revealed'));
      }));
    }

    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.dataset.loaded) return;

      const load = () => {
        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.querySelector('[data-rec-card]')) {
              this.innerHTML = fresh.innerHTML;
              this.revealSwapped();
            }
            this.dataset.loaded = 'true';
          })
          .catch(() => {
            /* keep the server-rendered fallback */
          });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            load();
          }
        }, { rootMargin: '240px' });
        observer.observe(this);
      } else {
        load();
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();

  } catch(e) { console.error(e); }
})();
})();
